<template>
    <div
        class="bg-indigo-50 px-4 py-5 border-b border-gray-200 sm:px-6 rounded relative group"
         :class="{'border border-red-500': errors.length !== 0}"
    >
        <div class="absolute right-0 top-0 mt-3 mr-2 cursor-pointer group-hover:block hidden" v-if="destinationsCount > 1"
             @click="deleteSelectedDestination">
            <TrashIcon class="h-4 w-4 text-gray-300 hover:text-gray-500" aria-hidden="true" ></TrashIcon>
        </div>
        <h4 class="text-lg leading-6 font-medium text-gray-900"
        v-if="destinationsCount === 1 || destinationId === 0"
        >Действие при сканировании кода</h4>

        <div class="mt-4">
            <destination-type :destination-id="destinationId"></destination-type>
        </div>

        <div>
            <component :is="destination.type" :destination-id="destinationId" class="mt-4" :errors="errors"></component>
        </div>

        <div class="mt-4">
            <destination-rule :destination-id="destinationId" :rules="destination.rules"></destination-rule>
        </div>

        <div class="mt-4">
            <pixel v-model="destination.pixel"></pixel>
        </div>
    </div>
</template>

<script>

import DestinationType from "./DestinationType.vue";
import DestinationRule from "./DestinationRule.vue";
import {mapActions, mapState} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";
import {TrashIcon} from '@heroicons/vue/24/outline'
import Link from "@/scripts/components/app/qrcodes/form/destination/type/Link.vue";
import Email from "@/scripts/components/app/qrcodes/form/destination/type/Email.vue";
import Sms from "@/scripts/components/app/qrcodes/form/destination/type/Sms.vue";
import Messenger from "@/scripts/components/app/qrcodes/form/destination/type/Messenger.vue";
import Vcard from "@/scripts/components/app/qrcodes/form/destination/type/Vcard.vue";
import Geolocation from "@/scripts/components/app/qrcodes/form/destination/type/Geolocation.vue";
import Pdf from "@/scripts/components/app/qrcodes/form/destination/type/Pdf.vue";
import Linktoapp from "@/scripts/components/app/qrcodes/form/destination/type/Linktoapp.vue";
import Call from "@/scripts/components/app/qrcodes/form/destination/type/Call.vue";
import Text from "@/scripts/components/app/qrcodes/form/destination/type/Text.vue";
import Totelegram from "@/scripts/components/app/qrcodes/form/destination/type/Totelegram.vue";
import Towhatsapp from "@/scripts/components/app/qrcodes/form/destination/type/Towhatsapp.vue";
import Pixel from "@/scripts/components/app/qrcodes/form/destination/extensions/Pixel.vue";

export default {
    components: {
        Pixel,
        DestinationType,
        DestinationRule,
        TrashIcon,
        Link,
        Email,
        Sms,
        Call,
        Text,
        Messenger,
        Vcard,
        Geolocation,
        Pdf,
        Linktoapp,
        Totelegram,
        Towhatsapp
    },

    props: {
        destination: {
            required: true
        },
        destinationId: {
            required: true
        },
        errors: {
            default: []
        }
    },

    computed: {
        ...mapState(qrCodeFormStore, ['destinationsCount'])
    },

    methods: {
        ...mapActions(qrCodeFormStore, ['updateDestination', 'deleteDestination']),
        deleteSelectedDestination() {
            this.deleteDestination(this.destinationId)
        }
    }
}
</script>

<style scoped>

</style>
